import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTitle } from '../../../context/TitleContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaMapMarkerAlt, FaEnvelope, FaPhone, FaClock, FaStore } from 'react-icons/fa';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BranchDetails = () => {
    const { id } = useParams();
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const [branch, setBranch] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // تحديد نوع المستخدم
    const getUserRole = () => {
        const storedStore = sessionStorage.getItem("storekhadamat");
        if (storedStore) {
            try {
                const parsed = JSON.parse(storedStore);
                return parsed.role;
            } catch {
                return 'store';
            }
        }
        return 'store';
    };

    const userRole = getUserRole();

    useEffect(() => {
        const title = userRole === 'pharmacy' ? 'تفاصيل فرع الصيدلية' : 'تفاصيل الفرع';
        setTitle(title);
        fetchBranchDetails();
    }, [id, setTitle, userRole]);

    const getAuthToken = () => {
        const storeData = sessionStorage.getItem('storekhadamat');
        if (storeData) {
            try {
                const parsed = JSON.parse(storeData);
                return parsed.token;
            } catch {
                return null;
            }
        }
        return null;
    };

    const fetchBranchDetails = async () => {
        try {
            setLoading(true);
            const token = getAuthToken();
            
            if (!token) {
                throw new Error('لا يوجد token للمصادقة');
            }

            const response = await axios.get(`${BASE_URL}/stores/store_branches/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            if (response.data.status === 'failed' || response.data.status === 'faild') {
                throw new Error(response.data.message || 'فشل في جلب تفاصيل الفرع');
            }

            setBranch(response.data.result || response.data.data);
        } catch (error) {
            setError(error.response?.data?.message || error.message || 'فشل في جلب تفاصيل الفرع');
            toast.error(error.response?.data?.message || error.message || 'فشل في جلب تفاصيل الفرع');
        } finally {
            setLoading(false);
        }
    };

    const LoadingSpinner = () => (
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
        </div>
    );

    if (loading) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <LoadingSpinner />
                        <p className="mt-3 text-muted">جاري تحميل التفاصيل...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !branch) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <div className="alert alert-danger">
                            <h4>خطأ</h4>
                            <p>{error || 'لم يتم العثور على الفرع'}</p>
                            <button 
                                className="btn btn-primary"
                                onClick={() => navigate('/store-branches')}
                            >
                                العودة للقائمة
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main_content">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="btn btn-outline-secondary d-flex align-items-center"
                        onClick={() => navigate('/store-branches')}
                        style={{ color: '#184194', textDecoration: 'none' }}>
                        <FaArrowLeft className="mx-2" />
                        العودة
                    </motion.button>
                </div>

                {/* Branch Details */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="card shadow-sm"
                    style={{ borderRadius: '12px' }}>
                    
                    <div className="card-header" style={{ backgroundColor: '#184194', color: 'white' }}>
                        <h4 className="mb-0">
                            <FaStore className="mx-2" />
                            {userRole === 'pharmacy' ? 'تفاصيل فرع الصيدلية' : 'تفاصيل الفرع'}
                        </h4>
                    </div>

                    <div className="card-body p-4">
                        <div className="row">
                            {/* عرض Logo و Cover */}
                            {(branch.logo || branch.cover) && (
                                <div className="col-12 mb-4">
                                    <div className="row">
                                        {/* Logo */}
                                        {branch.logo && branch.logo !== 'logo' && (
                                            <div className="col-md-6 mb-3">
                                                <h6 className="text-primary mb-2">
                                                    <FaStore className="mx-2" />
                                                    شعار الفرع (Logo)
                                                </h6>
                                                <div style={{
                                                    width: '200px',
                                                    height: '200px',
                                                    border: '2px solid #e9ecef',
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                }}>
                                                    <img
                                                        src={branch.logo}
                                                        alt="Branch Logo"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {/* Cover */}
                                        {branch.cover && branch.cover !== 'cover' && (
                                            <div className="col-md-12 mb-3">
                                                <h6 className="text-primary mb-2">
                                                    🖼️ صورة الغلاف (Cover)
                                                </h6>
                                                <div style={{
                                                    width: '100%',
                                                    maxWidth: '800px',
                                                    height: '300px',
                                                    border: '2px solid #e9ecef',
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                }}>
                                                    <img
                                                        src={branch.cover}
                                                        alt="Branch Cover"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <hr className="my-4" />
                                </div>
                            )}

                            {/* التفاصيل */}
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">اسم الفرع</h6>
                                        <p className="fw-medium">{branch.market_name}</p>
                                    </div>
                                    
                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">المعرف</h6>
                                        <p className="fw-medium">#{branch.id}</p>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">
                                            <FaEnvelope className="mx-2" />
                                            البريد الإلكتروني
                                        </h6>
                                        <p className="fw-medium">{branch.email}</p>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">
                                            <FaPhone className="mx-2" />
                                            رقم الهاتف
                                        </h6>
                                        <p className="fw-medium">{branch.phone}</p>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">الحالة</h6>
                                        <span className={`badge ${branch.status === '1' ? 'bg-success' : 'bg-danger'}`}>
                                            {branch.status === '1' ? 'نشط' : 'غير نشط'}
                                        </span>
                                    </div>

                                    {/* تم إلغاء عرض الحظر بناءً على طلب العميل */}

                                    {branch.lat && branch.lng && (
                                        <div className="col-md-12 mb-3">
                                            <h6 className="text-primary">
                                                <FaMapMarkerAlt className="mx-2" />
                                                الموقع على الخريطة
                                            </h6>
                                            <div style={{ height: '350px', borderRadius: '8px', overflow: 'hidden', border: '2px solid #e9ecef', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                                                <iframe
                                                    title="موقع الفرع"
                                                    width="100%"
                                                    height="100%"
                                                    frameBorder="0"
                                                    style={{ border: 0 }}
                                                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAHQSuklfkVa-mATYvbA7odk3_LpnKG-OA&q=${parseFloat(branch.lat).toFixed(7)},${parseFloat(branch.lng).toFixed(7)}&zoom=18&language=ar`}
                                                    allowFullScreen>
                                                </iframe>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                                <small className="text-muted">
                                                    الإحداثيات: {parseFloat(branch.lat).toFixed(7)}, {parseFloat(branch.lng).toFixed(7)}
                                                </small>
                                                <a 
                                                    href={`https://www.google.com/maps?q=${parseFloat(branch.lat).toFixed(7)},${parseFloat(branch.lng).toFixed(7)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm text-white"
                                                    style={{ backgroundColor: '#184194' }}>
                                                    فتح في Google Maps
                                                </a>
                                            </div>
                                        </div>
                                    )}

                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">تاريخ الإنشاء</h6>
                                        <p className="fw-medium">{branch.created_at}</p>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <h6 className="text-primary">آخر تحديث</h6>
                                        <p className="fw-medium">{branch.updated_at}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default BranchDetails;
